export default {
  common: {
    brand: 'USFans Spreadsheet',
    nav: {
      home: 'Inicio',
      categories: 'Categorías',
      guides: 'Guías',
      shoppingGuide: 'Guía de compra',
      safety: 'Seguridad',
      faq: 'Preguntas frecuentes',
    },
    cta: {
      spreadsheet: 'usfans spreadsheet',
      buyNow: 'buy it now',
      explore: 'Explora USFans Spreadsheet',
      browseDirectory: 'Explorar el directorio',
    },
    search: {
      placeholder: 'Busca USFans Spreadsheet, productos, categorías o guías…',
    },
    language: 'Idioma',
    footer: {
      tagline: 'Un centro de recursos independiente que te ayuda a encontrar, comparar y explorar recursos de USFans Spreadsheet: organizado, actualizado y multilingüe.',
      resources: 'Recursos',
      resourcesGuides: 'Guías',
      resourcesCategories: 'Categorías',
      resourcesSafety: 'Guía de seguridad',
      resourcesFaq: 'Preguntas frecuentes',
      company: 'Empresa',
      about: 'Acerca de',
      editorialPolicy: 'Política editorial',
      contact: 'Contacto',
      legal: 'Legal',
      privacy: 'Política de privacidad',
      terms: 'Términos',
      disclaimer: 'Aviso legal',
      rights: 'Todos los derechos reservados.',
    },
    languages: {
      en: 'English',
      pl: 'Polski',
      es: 'Español',
      fr: 'Français',
    },
  },
};